var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[(
      _vm.$route.name !== 'Login' &&
      _vm.$route.name !== 'StudyAbroad' &&
        _vm.$route.name !== 'ScholarshipForm' &&
        _vm.$route.name !== 'NavRegister' &&
        _vm.$route.name !== 'StudyAbroadFair' &&
        _vm.$route.name !== 'StudyAbroadFair1' &&
        _vm.$route.name !== 'StudyAbroadFair2' &&
        _vm.$route.name !== 'StudyAbroadFair3' 
    )?_c('Header'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),_vm._v(" "),(
      _vm.$route.name !== 'Login' &&
      _vm.$route.name !== 'StudyAbroad' &&
        _vm.$route.name !== 'ScholarshipForm' &&
        _vm.$route.name !== 'NavRegister' &&
        _vm.$route.name !== 'StudyAbroadFair' &&
        _vm.$route.name !== 'StudyAbroadFair1' &&
         _vm.$route.name !== 'StudyAbroadFair2' &&
        _vm.$route.name !== 'StudyAbroadFair3' &&
        _vm.$route.name !== 'ThaneFranchise' &&
        _vm.$route.name !== 'GujratFranchise' &&
        _vm.$route.name !== 'MiraRoadFranchise' &&
        _vm.$route.name !== 'LowerParelFranchise' &&
        _vm.$route.name !== 'RaipurFranchise' &&
        _vm.$route.name !== 'SolapurFranchise' &&
        _vm.$route.name !== 'NaviMumbaiFranchise' &&
        _vm.$route.name !== 'KarnatakaFranchise' &&
        _vm.$route.name !== 'DubaiFranchise' &&
        _vm.$route.name !== 'KuwaitFranchise' &&
        _vm.$route.name !== 'DeccanFranchise' &&
        _vm.$route.name !== 'KarveRoadFranchise' &&
        _vm.$route.name !== 'PimpleFranchise' &&
        _vm.$route.name !== 'CoimbatoreFranchise' &&
        _vm.$route.name !== 'KolkataFranchise' &&
        _vm.$route.name !== 'OMRChennaiFranchise'
    )?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4d49fc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1784
// module chunks = 1